/**
 * @param {object} state
 * @returns {{ title: ""; content: ""; actions: []; visible: false }}
 */
const selectDialog = (state) => state.dialog;

export const selectDialogList = (state) => selectDialog(state).dialogList;
